import { render, staticRenderFns } from "./华普home.vue?vue&type=template&id=22cf407e&scoped=true&"
import script from "./华普home.vue?vue&type=script&lang=js&"
export * from "./华普home.vue?vue&type=script&lang=js&"
import style0 from "./华普home.vue?vue&type=style&index=0&id=22cf407e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf407e",
  null
  
)

export default component.exports